
import React from 'react'
import icon from './svgs/person.svg'
import { BaseIcon } from './_base'

export const PersonIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
